import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAppStore = defineStore('app', () => {
  const activeViewProduct = ref(null)
  const setActiveViewProduct = (product) => {
    activeViewProduct.value = product
  }

  return {
    activeViewProduct,
    setActiveViewProduct
  }
})
